import { render, staticRenderFns } from "./PagePerformanceReviewDiscussion.vue?vue&type=template&id=53c02646&"
import script from "./PagePerformanceReviewDiscussion.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports